import { ApiService } from './../../../services/api.service';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
exporting(Highcharts);
import Drilldown from 'highcharts/modules/drilldown';
Drilldown(Highcharts);
import highcharts3D from 'highcharts/highcharts-3d';
highcharts3D(Highcharts);
import more from 'highcharts/highcharts-more';
more(Highcharts);
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { JwtService } from 'src/app/services/jwt.service';

Highcharts.setOptions({
  credits: {
    enabled: false,
  },
  exporting: {
    buttons: {
      contextButton: {
        menuItems: ['viewFullscreen'],
      },
    },
    enabled: true,
  },
  chart: {
    shadow: true,
    style: {
      fontFamily: 'Poppins, sans-serif',
    },
  },
});

let component: any;

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.css'],
})
export class AnalyticsComponent implements OnInit {
  fromDate: Date;
  toDate: Date;
  currDate: Date;
  loaded = false;
  activityList: any;
  activity: any;
  activityDate: string[] = [];
  listData: any;
  dateChart: any[] = [];
  usersChart: any[] = [];
  successChart: any[] = [];
  clientChart: any[] = [];
  clientusersChart: any[] = [];
  categoryChart: any[] = [];
  categoryClientsChart: any[] = [];
  updateFlag: boolean = false;
  updateFlag1: boolean = false;
  updateFlag2: boolean = false;
  clientFlag: boolean = false;
  chart;
  linechart;
  chart3d;
  userName: string;
  clientName: string;
  datewiseData: any[] = [];
  bubbleChart;
  bubble: boolean = false;
  logCount: number;
  logFilter: number;
  userCount: number;
  userFilter: number;
  clientCount: number;
  clientFilter: number;
  oneToOne: boolean;

  constructor(private jwt: JwtService, private api: ApiService, private mixpanel: MixpanelService, private snackbar: MatSnackBar) {
    this.currDate = new Date();
  }

  ngOnInit(): void {
    this.mixpanel.track("page_view", { page: "Analytics", category: "Dashboard", button: "-"  })
    this.jwt.check();
    this.bubble = false;
    component = this;
    let param = {
      fromDate: '',
      toDate: '',
    };
    this.getData(param);
  }

  reset() {
    this.bubble = false;
    this.fromDate = null;
    this.toDate = null;
    let param = {
      fromDate: '',
      toDate: '',
    };
    this.getData(param);
  }

  onDateChanged() {
    this.bubble = false;
    if (this.fromDate && this.toDate) {
      if (this.fromDate > this.toDate) {
        this.fromDate = null;
        this.toDate = null;
        this.snackbar.open(
          'From Date should not be exceed To Date',
          undefined,
          {
            duration: 5000,
            panelClass: 'failure',
          }
        );
        return;
      }
      let todayMinus90 = new Date(this.toDate);
      todayMinus90.setDate(todayMinus90.getDate() - 90);
      if (this.fromDate < todayMinus90) {
        this.fromDate = null;
        this.toDate = null;
        this.snackbar.open('Only 3 months data can be viewed', undefined, {
          duration: 5000,
          panelClass: 'failure',
        });
        return;
      }
      let param = {
        fromDate: this.getDateAsApiFormat(this.fromDate),
        toDate: this.getDateAsApiFormat(this.toDate),
      };
      this.getData(param);
    }
  }

  getData(param) {
    this.loaded = false;
    this.api.logs(param).subscribe(
      (data: any) => {
        this.loaded = true;
        if (data.status) {
          this.listData = data.data;
          this.activityList = this.listData.rows;
          this.activity = JSON.parse(JSON.stringify(this.activityList));
          this.activityDate = [];
          for (let Key in this.activityList) {
            this.activityDate.unshift(Key);
          }
          this.datesChart();
          this.charts( true );
          this.categories();
        } else {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
        }
      },
      (error) => {
        this.loaded = true;
      }
    );
  }

  commonFilter() {
    this.bubble = true;
    this.activityList = {};
    let activityList = {};
    activityList = JSON.parse(JSON.stringify(this.activity));
    this.activityList = activityList;
    let user = this.userName;
    let client = this.clientName;
    if (user) {
      this.activityDate.forEach((element) => {
        let filtered = this.activityList[element].filter(function (item) {
          return item.actionBy === user;
        });
        this.activityList[element] = filtered;
      });
    }
    if (client) {
      this.activityDate.forEach((element) => {
        let filtered = this.activityList[element].filter(function (item) {
          return item.client === client;
        });
        this.activityList[element] = filtered;
      });
    }
    this.datesChart();
    this.charts( false );
    this.categories();
  }

  getDateAsApiFormat(e) {
    e = new Date(e);
    return `${e.getFullYear()}-${this.twoDigit(
      e.getMonth() + 1
    )}-${this.twoDigit(e.getDate())}`;
  }

  twoDigit(e) {
    return String(
      Number(e).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })
    );
  }

  pointSelect(e: string) {
    this.bubble = false;
    this.fromDate = this.toDate = new Date();
    if (e == 'Yesterday') {
      this.fromDate.setDate(this.fromDate.getDate() - 1);
    } else if (e == 'Today') {
      this.fromDate.setDate(this.fromDate.getDate());
    } else {
      let dateParts = e.split('/');
      this.fromDate.setMonth(parseInt(dateParts[1]) - 1);
      this.fromDate.setFullYear(parseInt(dateParts[2]));
      this.fromDate.setDate(parseInt(dateParts[0]));
    }
    this.toDate = this.fromDate;
    let param = {
      fromDate: this.getDateAsApiFormat(this.fromDate),
      toDate: this.getDateAsApiFormat(this.toDate),
    };
    this.getData(param);
  }

  datesChart() {
    this.dateChart.length = 0;
    this.activityDate.forEach((ele: any) => {
      let json: JSON = <JSON>(<unknown>{
        name: ele,
        y: this.activityList[ele].length,
      });
      this.dateChart.push(json);
    });
    this.chartOptions.xAxis = {
      categories: this.activityDate,
    };
  }

  charts( bool ) {
    this.clients( bool );
    this.usersChart.length = 0;
    this.successChart.length = 0;
    this.datewiseData.length = 0;
    let user: any[] = [];
    if (this.activityDate.length <= 0) {
      return;
    }
    this.activityDate.forEach((element) => {
      let jsonData: JSON = <JSON>(<unknown>{
        users: [],
        clients: [],
      });
      this.datewiseData.push(jsonData);
      this.activityList[element].forEach((ele) => {
        let users = ele.actionBy;
        let clients = ele.client;
        if (
          this.datewiseData[this.datewiseData.length - 1]['users'].indexOf(
            users
          ) == -1
        ) {
          this.datewiseData[this.datewiseData.length - 1]['users'].push(users);
        }
        if (
          this.datewiseData[this.datewiseData.length - 1]['clients'].indexOf(
            clients
          ) == -1
        ) {
          this.datewiseData[this.datewiseData.length - 1]['clients'].push(
            clients
          );
        }
        if (user.indexOf(users) != -1) {
          this.usersChart[this.usersChart.findIndex((i) => i.name == users)][
            'y'
          ] += 1;
          if (ele.status == true) {
            this.successChart[
              this.successChart.findIndex((j) => j.name == users)
            ]['data'][0][1] += 1;
          } else {
            this.successChart[
              this.successChart.findIndex((j) => j.name == users)
            ]['data'][1][1] += 1;
          }
        } else {
          let json: JSON = <JSON>(<unknown>{
            name: users,
            y: 1,
            drilldown: users,
          });
          this.usersChart.push(json);
          let json1: JSON = ele.status ? <JSON>(<unknown>{
                name: users,
                id: users,
                data: [
                  ['success', 1],
                  ['failure', 0],
                ],
              }) : <JSON>(<unknown>{
                name: users,
                id: users,
                data: [
                  ['success', 0],
                  ['failure', 1],
                ],
              });
          this.successChart.push(json1);
          user.push(users);
        }
      });
    });

    user.forEach((ele) => {
      if (
        this.successChart[this.successChart.findIndex((j) => j.name == ele)][
          'data'
        ][0][1] == 0
      ) {
        this.successChart[this.successChart.findIndex((j) => j.name == ele)][
          'data'
        ][0][1] = null;
      }
      if (
        this.successChart[this.successChart.findIndex((j) => j.name == ele)][
          'data'
        ][1][1] == 0
      ) {
        this.successChart[this.successChart.findIndex((j) => j.name == ele)][
          'data'
        ][1][1] = null;
      }
    });
    this.updateFlag = true;
    if( bool ) {
      this.userCount = this.usersChart.length;
      this.userFilter = this.usersChart.length;
    } else {
      this.userFilter = this.usersChart.length;
    }
  }

  clients( bool ) {
    let client: any[] = [];
    this.clientChart.length = 0;
    if (this.activityDate.length <= 0) {
      return;
    }
    this.activityDate.forEach((element) => {
      this.activityList[element].forEach((ele) => {
        let clients = ele.client;
        if (client.indexOf(clients) != -1) {
          this.clientChart[
            this.clientChart.findIndex((i) => i.name == clients)
          ]['y'] += 1;
        } else {
          let json: JSON = <JSON>(<unknown>{
            name: clients,
            y: 1,
            drilldown: clients,
          });
          this.clientChart.push(json);
          client.push(clients);
        }
      });
    });
    if (this.clientName) {
      this.chartOptions2.subtitle.text = this.clientName;
    } else if (this.fromDate && this.toDate) {
      this.chartOptions2.subtitle.text = `${this.fromDate.toDateString()} - ${this.toDate.toDateString()}`;
    } else {
      this.chartOptions2.subtitle.text = 'OverAll';
    }
    this.clientusers(client);
    this.updateFlag1 = true;
    if ( bool ) {
      this.logCount = this.logs();
      this.logFilter = this.logs();
      this.clientCount = this.clientChart.length;
      this.clientFilter = this.clientChart.length;
    } else {
      this.logFilter = this.logs();
      this.clientFilter = this.clientChart.length;
    }
  }

  clientusers(client) {
    this.clientusersChart.length = 0;
    client.forEach((ele) => {
      let json: JSON = <JSON>(<unknown>{
        id: ele,
        name: ele,
        data: [],
      });
      this.clientusersChart.push(json);
      let users: any[] = [];
      let clientusers: any[] = [];
      this.activityDate.forEach((element) => {
        this.activityList[element].forEach((e) => {
          let user = e.actionBy;
          if (e.client == ele) {
            if (users.indexOf(user) == -1) {
              clientusers.push([user, 1]);
              users.push(user);
            } else {
              let index = clientusers.findIndex((i) => i[0] == user);
              clientusers[index][1] += 1;
            }
          }
        });
      });
      this.clientusersChart[
        this.clientusersChart.findIndex((j) => j.name == ele)
      ]['data'] = clientusers;
    });
  }

  client(e: string) {
    if (this.chart3d) {
      this.chart3d.drillUp({ animation: false });
    }
    this.clientChart.length = 0;
    let client: any[] = [];
    this.activityDate.forEach((element) => {
      this.activityList[element].forEach((ele) => {
        let clients = ele.client;
        if (ele.actionBy == e) {
          if (client.indexOf(clients) != -1) {
            this.clientChart[
              this.clientChart.findIndex((i) => i.name == clients)
            ]['y'] += 1;
          } else {
            let json: JSON = <JSON>(<unknown>{
              name: clients,
              y: 1,
              drilldown: clients,
            });
            this.clientChart.push(json);
            client.push(clients);
          }
        }
      });
    });
    this.chartOptions2.subtitle.text = e
      .toLowerCase()
      .split(' ')
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ');
    this.clientusers(client);
    this.updateFlag1 = true;
    this.logFilter = this.logs();
    this.clientFilter = this.clientChart.length;
  }

  logs() {
    let sum = 0;
    if (this.clientChart.length > 0) {
      this.clientChart.forEach((ele) => {
        sum += ele.y;
      });
      return sum;
    }
    return sum;
  }

  categories() {
    this.categoryChart.length = 0;
    this.categoryClientsChart.length = 0;
    let categories: any[] = [];
    let clientCategories: any[] = [];
    this.activityDate.forEach((element) => {
      this.activityList[element].forEach((ele) => {
        let category = ele.category;
        let client = ele.client;
        let clientCategory = `${client}${category}`;
        let user = ele.actionBy;
        if (category != null) {
          if (categories.indexOf(category) != -1) {
            if (
              this.categoryChart[
                this.categoryChart.findIndex((j) => j.name == category)
              ]['data'][
                this.categoryChart[
                  this.categoryChart.findIndex((j) => j.name == category)
                ]['data'].findIndex((j) => j.name == client)
              ]
            ) {
              this.categoryChart[
                this.categoryChart.findIndex((j) => j.name == category)
              ]['data'][
                this.categoryChart[
                  this.categoryChart.findIndex((j) => j.name == category)
                ]['data'].findIndex((j) => j.name == client)
              ]['value'] += 1;
            } else {
              this.categoryChart[
                this.categoryChart.findIndex((j) => j.name == category)
              ]['data'].push({
                name: client,
                value: 1,
                drilldown: clientCategory
              });
            }
          } else {
            let json: JSON = <JSON>(<unknown>{
              name: category,
              data: [
                {
                  name: client,
                  value: 1,
                  drilldown: clientCategory
                },
              ],
            });
            this.categoryChart.push(json);
            categories.push(category);
          }
          if( clientCategories.indexOf(clientCategory) != -1 ) {
            if (
              this.categoryClientsChart[
                this.categoryClientsChart.findIndex((j) => j.id == clientCategory)
              ]['data'][
                this.categoryClientsChart[
                  this.categoryClientsChart.findIndex((j) => j.id == clientCategory)
                ]['data'].findIndex((j) => j.name == user)
              ]
            ) {
              this.categoryClientsChart[
                this.categoryClientsChart.findIndex((j) => j.id == clientCategory)
              ]['data'][
                this.categoryClientsChart[
                  this.categoryClientsChart.findIndex((j) => j.id == clientCategory)
                ]['data'].findIndex((j) => j.name == user)
              ]['value']+=1;
            } else {
              this.categoryClientsChart[
                this.categoryClientsChart.findIndex((j) => j.id == clientCategory)
              ]['data'].push({
                name: user,
                value: 1,
              });
              this.categoryClientsChart[
                this.categoryClientsChart.findIndex((j) => j.id == clientCategory)
              ]['name'] = client
            }
          } else {
            let json1: JSON = <JSON>(<unknown>{
              name: client,
              type: 'packedbubble',
              id: clientCategory,
              data: [
                {
                  name: user,
                  value: 1,
                },
              ],
            });
            this.categoryClientsChart.push(json1);
            clientCategories.push(clientCategory)
          }
        }
      });
    });
    if ( this.bubbleChart ) {
      this.bubbleChart.drillUp({ animation: false });
    }
    if( this.bubbleChart && this.categoryChart.length && this.bubble ) {
      this.chartOptions3.series = this.categoryChart;
      this.chartOptions3.drilldown = { series : this.categoryClientsChart };
      this.oneToOne = true;
      this.bubbleChart.update( this.chartOptions3, true, this.oneToOne || false );
    }
    this.updateFlag2 = true;
  }

  highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    chart: {
      plotShadow: false,
      type: 'line',
    },
    xAxis: {
      categories: this.activityDate,
    },
    yAxis: {
      title: {
        text: '<b>Number of Logs</b>',
      },
    },
    title: {
      text: 'Activity Log',
      align: 'center',
    },
    tooltip: {
      formatter: function () {
        return (
          '<b>' +
          this.point.name +
          '</b><br><br>' +
          '<b>Total Logs:</b> ' +
          component.activityList[this.point.name].length +
          '<br>' +
          '<b>Unique Users:</b> ' +
          component.datewiseData[this.point.index]['users'].length +
          '<br>' +
          '<b>Unique Clients:</b> ' +
          component.datewiseData[this.point.index]['clients'].length
        );
      },
    },
    plotOptions: {
      line: {
        allowPointSelect: true,
        cursor: 'pointer',
      },
      series: {
        cursor: 'pointer',
        point: {
          events: {
            click: function (e) {
              component.pointSelect(e.point.name);
            },
          },
        },
      },
    },
    series: [
      {
        type: 'line',
        name: 'days',
        data: this.dateChart,
        showInLegend: false,
      },
    ],
  };

  chartOptions1: Highcharts.Options = {
    chart: {
      plotShadow: false,
      type: 'pie',
      events: {
        drilldown: function (e) {
          component.userName = e.point.name;
          component.commonFilter();
          component.client(e.point.name);
        },
        drillup: function () {
          component.userName = null;
          component.commonFilter();
          component.clients( false );
        },
      },
    },
    title: {
      text: 'Users',
      align: 'center',
    },
    tooltip: {
      pointFormat:
        '<b>Percentage:</b> {point.percentage:.1f}%<br><b>Total Logs:</b> {point.y}',
      headerFormat: '<b>{point.key}</b><br>',
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
        },
        point: {
          events: {
            legendItemClick: function (event) {
              if (event.target.visible === false) {
                return true;
              }
              let count = 0;
              event.target.series.data.forEach((e) => {
                if (e.visible === true) {
                  count += 1;
                }
              });
              return count > 1;
            },
          },
        },
        showInLegend: true,
      },
    },
    series: [
      {
        type: 'pie',
        data: this.usersChart,
      },
    ],
    drilldown: {
      series: this.successChart,
      animation: {
        duration: 10,
      },
    },
  };

  chartOptions2: Highcharts.Options = {
    chart: {
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
      },
      marginTop: 40,
      marginBottom: 30,
      events: {
        drilldown: function (e) {
          component.clientName = e.point.name;
          component.commonFilter();
        },
        drillup: function () {
          component.clientName = null;
          component.commonFilter();
        },
      },
    },
    title: {
      text: 'Clients',
      align: 'center',
    },
    subtitle: {
      text: 'OverAll',
      align: 'center',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
      },
    },
    tooltip: {
      formatter: function () {
        return (
          '<b>' +
          this.point.name +
          '</b><br>' +
          '<b>Percentage:</b> ' +
          this.point.percentage.toFixed(1) +
          '%<br>' +
          '<b>Total Logs:</b> ' +
          this.y +
          '<br>' +
          '<b>Unique Users:</b> ' +
          component.clientusersChart[this.point.index]['data'].length
        );
      },
    },
    plotOptions: {
      pie: {
        innerSize: 100,
        depth: 45,
      },
    },
    series: [
      {
        type: 'pie',
        data: this.clientChart,
        dataLabels: {
          enabled: false,
          format: '{point.name} - {point.y:.1f}', // one decimal
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
        point: {
          events: {
            legendItemClick: function (event) {
              if (event.target.visible === false) {
                return true;
              }
              let count = 0;
              event.target.series.data.forEach((e) => {
                if (e.visible === true) {
                  count += 1;
                }
              });
              return count > 1;
            },
          },
        },
        showInLegend: true,
      },
    ],
    drilldown: {
      series: this.clientusersChart,
      animation: {
        duration: 10,
      },
    },
  };

  chartOptions3: Highcharts.Options = {
    chart: {
      type: 'packedbubble',
      height: window.innerWidth < 768 ? '100%' : '40%',
      renderTo: 'container',
    },
    title: {
      text: 'Categories',
      align: 'center',
    },
    tooltip: {
      useHTML: true,
      pointFormat: '<b>{point.name}:</b> {point.value} logs',
    },
    plotOptions: {
      packedbubble: {
        minSize: '50%',
        maxSize: '100%',
        zMin: 0,
        zMax: 1000,
        draggable: false,
        keyboardNavigation: false,
        layoutAlgorithm: {
          gravitationalConstant: 0.05,
          splitSeries: true,
          seriesInteraction: false,
          dragBetweenSeries: true,
          parentNodeLimit: true,
          enableSimulation: false
        },
        dataLabels: {
          enabled: true,
          format: '{point.name}',
          style: {
            color: 'black',
            textOutline: 'none',
            fontWeight: 'bold',
          },
        },
        events: {
          legendItemClick: function (event) {
            if (event.target.visible === false) {
              return true;
            }
            let count = 0;
            event.target.chart.series.forEach((e) => {
              if (e.visible === true) {
                count += 1;
              }
            });
            return count > 1;
          },
        }
       } as any,
    },
    series: this.categoryChart,
    drilldown: {
      series: this.categoryClientsChart
    }
  };

  saveInstance(chartInstance) {
    this.linechart = chartInstance;
  }

  saveInstance1(chartInstance) {
    this.chart = chartInstance;
  }

  saveInstance2(chartInstance) {
    this.chart3d = chartInstance;
  }

  saveInstance3(chartInstance) {
    this.bubbleChart = chartInstance;
  }

  onExport = () => {
    // using highcharts
    // (Highcharts as any).exportCharts(
    //   [Highcharts.charts[0], Highcharts.charts[1], Highcharts.charts[2]],
    //   {
    //     type: 'application/pdf',
    //   }
    // );
    const div = document.querySelector('#analytic-charts') as HTMLElement;
    html2canvas(div, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const padding = 10;
      const aspectRatio = canvas.width / canvas.height;
      const width = 211 - 2 * padding;
      const height = width / aspectRatio;
      const doc = new jsPDF();
      // doc.setPageSize(width, height);
      doc.addImage(imgData, 'JPEG', padding, padding, width, height);
      doc.save('analytics.pdf');
    });
  };
}
